import { getMessageMetadata, getIsVisible, getRecipients, getSenders } from './channelCapabilityGetters';
export const getIsMetadataEditableAndVisible = capabilitiesBlob => {
  if (!capabilitiesBlob) return false;
  return Boolean(getMessageMetadata(capabilitiesBlob) && getIsVisible(getRecipients(capabilitiesBlob)) && getIsVisible(getSenders(capabilitiesBlob)));
};